/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiV0InspectionApprovePost } from '../fn/inspection/api-v-0-inspection-approve-post';
import { ApiV0InspectionApprovePost$Params } from '../fn/inspection/api-v-0-inspection-approve-post';
import { apiV0InspectionCreatePost } from '../fn/inspection/api-v-0-inspection-create-post';
import { ApiV0InspectionCreatePost$Params } from '../fn/inspection/api-v-0-inspection-create-post';
import { apiV0InspectionDeleteByIdDelete } from '../fn/inspection/api-v-0-inspection-delete-by-id-delete';
import { ApiV0InspectionDeleteByIdDelete$Params } from '../fn/inspection/api-v-0-inspection-delete-by-id-delete';
import { apiV0InspectionGetByCompanyGet$Json } from '../fn/inspection/api-v-0-inspection-get-by-company-get-json';
import { ApiV0InspectionGetByCompanyGet$Json$Params } from '../fn/inspection/api-v-0-inspection-get-by-company-get-json';
import { apiV0InspectionGetByCompanyGet$Plain } from '../fn/inspection/api-v-0-inspection-get-by-company-get-plain';
import { ApiV0InspectionGetByCompanyGet$Plain$Params } from '../fn/inspection/api-v-0-inspection-get-by-company-get-plain';
import { apiV0InspectionUpdatePost } from '../fn/inspection/api-v-0-inspection-update-post';
import { ApiV0InspectionUpdatePost$Params } from '../fn/inspection/api-v-0-inspection-update-post';
import { Inspection } from '../models/inspection';

@Injectable({ providedIn: 'root' })
export class InspectionService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiV0InspectionGetByCompanyGet()` */
  static readonly ApiV0InspectionGetByCompanyGetPath = '/api/v0/inspection/getByCompany';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0InspectionGetByCompanyGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0InspectionGetByCompanyGet$Plain$Response(params?: ApiV0InspectionGetByCompanyGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Inspection>>> {
    const obs = apiV0InspectionGetByCompanyGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0InspectionGetByCompanyGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0InspectionGetByCompanyGet$Plain(params?: ApiV0InspectionGetByCompanyGet$Plain$Params, context?: HttpContext): Observable<Array<Inspection>> {
    const resp = this.apiV0InspectionGetByCompanyGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<Inspection>>): Array<Inspection> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0InspectionGetByCompanyGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0InspectionGetByCompanyGet$Json$Response(params?: ApiV0InspectionGetByCompanyGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Inspection>>> {
    const obs = apiV0InspectionGetByCompanyGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0InspectionGetByCompanyGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0InspectionGetByCompanyGet$Json(params?: ApiV0InspectionGetByCompanyGet$Json$Params, context?: HttpContext): Observable<Array<Inspection>> {
    const resp = this.apiV0InspectionGetByCompanyGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<Inspection>>): Array<Inspection> => r.body)
    );
  }

  /** Path part for operation `apiV0InspectionCreatePost()` */
  static readonly ApiV0InspectionCreatePostPath = '/api/v0/inspection/create';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0InspectionCreatePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0InspectionCreatePost$Response(params?: ApiV0InspectionCreatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiV0InspectionCreatePost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0InspectionCreatePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0InspectionCreatePost(params?: ApiV0InspectionCreatePost$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiV0InspectionCreatePost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiV0InspectionUpdatePost()` */
  static readonly ApiV0InspectionUpdatePostPath = '/api/v0/inspection/update';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0InspectionUpdatePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0InspectionUpdatePost$Response(params?: ApiV0InspectionUpdatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiV0InspectionUpdatePost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0InspectionUpdatePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0InspectionUpdatePost(params?: ApiV0InspectionUpdatePost$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiV0InspectionUpdatePost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiV0InspectionApprovePost()` */
  static readonly ApiV0InspectionApprovePostPath = '/api/v0/inspection/approve';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0InspectionApprovePost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0InspectionApprovePost$Response(params?: ApiV0InspectionApprovePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiV0InspectionApprovePost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0InspectionApprovePost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0InspectionApprovePost(params?: ApiV0InspectionApprovePost$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiV0InspectionApprovePost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiV0InspectionDeleteByIdDelete()` */
  static readonly ApiV0InspectionDeleteByIdDeletePath = '/api/v0/inspection/deleteById';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0InspectionDeleteByIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0InspectionDeleteByIdDelete$Response(params?: ApiV0InspectionDeleteByIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiV0InspectionDeleteByIdDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0InspectionDeleteByIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0InspectionDeleteByIdDelete(params?: ApiV0InspectionDeleteByIdDelete$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiV0InspectionDeleteByIdDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
